import Header from "../components/Header";
import React from "react";

const ContactUs: React.FC = () => {
  return (
      <div>
          <Header props={ {showInstallButton: true}}/>
          <div className="relative z-10">
              <div className="h-screen">
                  <section className="relative z-10 overflow-hidden pt-28 lg:pt-[150px]">
                      <div className="container">
                          <div className="-mx-4 flex flex-wrap items-center">
                              <div className="w-full px-4 md:w-8/12 lg:w-7/12">
                                  <div className="mb-8 max-w-[570px] md:mb-0 lg:mb-12"><h1
                                      className="mb-5 text-2xl font-bold text-black dark:text-white sm:text-3xl">Contact
                                      Us</h1><p className="text-base font-medium leading-relaxed text-body-color">You
                                      can contact us with any questions</p></div>
                              </div>
                              <div className="w-full px-4 md:w-4/12 lg:w-5/12">
                                  <div className="text-end">
                                      <ul className="flex items-center md:justify-end">
                                          <li className="flex items-center"><a
                                              className="pr-1 text-base font-medium text-body-color hover:text-primary"
                                              href="/">Home</a><span
                                              className="mr-3 block h-2 w-2 rotate-45 border-t-2 border-r-2 border-body-color"></span>
                                          </li>
                                          <li className="text-base font-medium text-primary">Contact Us</li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </section>
                  <section id="contact">
                      <div className="container">
                          <div className="-mx-4 flex flex-wrap mb-24">
                              <div className="w-full px-4">
                                  <div
                                      className="wow fadeInUp mb-12 rounded-md bg-blue-50 py-11 px-8 dark:bg-dark sm:p-[55px] lg:mb-5 lg:px-8 xl:p-[55px]"
                                      data-wow-delay=".15s ">E-mail: <a
                                      className="relative inline-flex items-center tap-highlight-transparent outline-none data-[focus-visible=true]:z-10 data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2 text-medium text-primary no-underline hover:opacity-80 active:opacity-disabled transition-opacity"
                                      role="link"
                                      href="mailto:pdfbliss@gmail.com">pdfbliss@gmail.com</a></div>
                              </div>
                          </div>
                      </div>
                  </section>
              </div>
          </div>
      </div>
  )
}

export default ContactUs;